(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/services/swedbank-express-service.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/services/swedbank-express-service.js');
'use strict';

var _svs;
const jupiter = svs.core.jupiter;
const logger = svs.accountservicesReact.deposit.swedbankExpress.logger;
const _svs$accountservicesR = svs.accountservicesReact.deposit.constants.swedbankExpress,
  displayStatus = _svs$accountservicesR.displayStatus,
  oauthStatus = _svs$accountservicesR.oauthStatus;
const isRc = ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservicesReact) === null || _svs === void 0 || (_svs = _svs.deposit) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 ? void 0 : _svs.isRc) || false;
const getErrorNumber = error => {
  let errorCode = 1;
  if (error && error.code && error.code > 0) {
    errorCode = error.code;
  }
  logger.debug('Call to getErrorNumber, errorCode: ', errorCode);
  return errorCode;
};


const getBankAccountsAsync = async () => {
  try {
    const options = {
      method: 'GET',
      path: "/swedbankExpress/".concat(isRc ? '99' : '1', "/getUserAccountList")
    };
    logger.debug('Call to getBankAccountsAsync with options: ', options);
    const _await$jupiter$callAs = await jupiter.callAsync(options),
      response = _await$jupiter$callAs.response;
    logger.debug('Call to getBankAccountsAsync response: ', response);
    return {
      status: displayStatus.SUCCESS,
      bankName: response.bankName,
      bankAccounts: response.accounts
    };
  } catch (error) {
    logger.info('*** Error getting BankAccounts Async, error code', error === null || error === void 0 ? void 0 : error.code);
    return {
      status: displayStatus.ERROR,
      errorCode: getErrorNumber(error)
    };
  }
};

const getBankListAsync = async () => {
  try {
    const options = {
      method: 'GET',
      path: "/swedbankExpress/".concat(isRc ? '99' : '1', "/getBankList")
    };
    logger.debug('Call to getBankListAsync with options: ', options);
    const _await$jupiter$callAs2 = await jupiter.callAsync(options),
      response = _await$jupiter$callAs2.response;
    logger.debug('Call to getBankListAsync response: ', response);
    return {
      status: displayStatus.SUCCESS,
      bankSubsidiaries: response.bankSubsidiaries
    };
  } catch (error) {
    logger.info('*** Error getting BankList Async, error code', error === null || error === void 0 ? void 0 : error.code);
    return {
      status: displayStatus.ERROR,
      errorCode: getErrorNumber(error)
    };
  }
};

const postInitiateNewConsentAsync = async _ref => {
  let _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    _ref$bankSubsidiaryId = _ref.bankSubsidiaryId,
    bankSubsidiaryId = _ref$bankSubsidiaryId === void 0 ? '' : _ref$bankSubsidiaryId;
  try {
    var _response$challengeDa, _response$challengeDa2;
    const options = {
      method: 'POST',
      path: "/swedbankExpress/".concat(isRc ? '99' : '1', "/authNewBank"),
      data: {
        isMobile: isMobile ? 1 : 0
      }
    };
    if (bankSubsidiaryId && bankSubsidiaryId.length > 0) {
      options.data.bankSubsidiaryId = bankSubsidiaryId;
    }
    logger.debug('Call to postInitiateNewConsentAsync with options: ', options);
    const _await$jupiter$callAs3 = await jupiter.callAsync(options),
      response = _await$jupiter$callAs3.response;
    logger.debug('Call to postInitiateNewConsentAsync response: ', response);
    logger.debug('Call to postInitiateNewConsentAsync response.challengeData: ', response === null || response === void 0 ? void 0 : response.challengeData);
    return {
      status: displayStatus.SUCCESS,
      authorizeId: response === null || response === void 0 ? void 0 : response.authorizeId,
      autoStartToken: response === null || response === void 0 || (_response$challengeDa = response.challengeData) === null || _response$challengeDa === void 0 ? void 0 : _response$challengeDa.autoStartToken,
      imageId: response === null || response === void 0 || (_response$challengeDa2 = response.challengeData) === null || _response$challengeDa2 === void 0 ? void 0 : _response$challengeDa2.imageId
    };
  } catch (error) {
    logger.info('*** Error posting postInitiateNewConsentAsync Async error code', error === null || error === void 0 ? void 0 : error.code);
    return {
      status: displayStatus.ERROR,
      errorCode: getErrorNumber(error)
    };
  }
};

const postPollAuthNewBankStatusAsync = async _ref2 => {
  let authorizeId = _ref2.authorizeId,
    _ref2$bankSubsidiaryI = _ref2.bankSubsidiaryId,
    bankSubsidiaryId = _ref2$bankSubsidiaryI === void 0 ? '' : _ref2$bankSubsidiaryI;
  try {
    const options = {
      method: 'POST',
      path: "/swedbankExpress/".concat(isRc ? '99' : '1', "/pollAuthNewBankStatus"),
      data: {
        authorizeId
      }
    };
    if (bankSubsidiaryId && bankSubsidiaryId.length > 0) {
      options.data.bankSubsidiaryId = bankSubsidiaryId;
    }
    logger.debug('Call to postPollAuthNewBankStatusAsync with options: ', options);
    const _await$jupiter$callAs4 = await jupiter.callAsync(options),
      response = _await$jupiter$callAs4.response;
    logger.debug('Call to postPollAuthNewBankStatusAsync response: ', response);
    return {
      status: displayStatus.SUCCESS,
      statusEnum: response.statusEnum
    };
  } catch (error) {
    logger.info('*** Error posting postPollAuthNewBankStatusAsync Async error code', error === null || error === void 0 ? void 0 : error.code);
    return {
      status: displayStatus.ERROR,
      statusEnum: oauthStatus.oauth2sts_UNKNOWN_INTERNAL_ISSUE,
      errorCode: getErrorNumber(error)
    };
  }
};

const postInitiateDepositAsync = async _ref3 => {
  let _ref3$isMobile = _ref3.isMobile,
    isMobile = _ref3$isMobile === void 0 ? false : _ref3$isMobile,
    accountNumber = _ref3.accountNumber,
    amount = _ref3.amount;
  try {
    var _response$challengeDa3, _response$challengeDa4, _response$challengeDa5;
    const options = {
      method: 'POST',
      path: "/swedbankExpress/".concat(isRc ? '99' : '1', "/initiateDeposit"),
      data: {
        isMobile: isMobile ? 1 : 0,
        bban: accountNumber,
        amount
      }
    };
    logger.debug('** Call to postInitiateDepositAsync with options: ', options);

    const _await$jupiter$callAs5 = await jupiter.callAsync(options),
      response = _await$jupiter$callAs5.response;
    logger.debug('Call to postInitiateDepositAsync response: ', response);
    logger.debug('Call to postInitiateDepositAsync imageId: ', response === null || response === void 0 || (_response$challengeDa3 = response.challengeData) === null || _response$challengeDa3 === void 0 ? void 0 : _response$challengeDa3.imageId);
    logger.debug('Call to postInitiateDepositAsync autoStartToken: ', response === null || response === void 0 ? void 0 : response.autoStartToken);
    return {
      status: displayStatus.SUCCESS,
      errorCode: null,
      paymentId: response.paymentId,
      autoStartToken: response === null || response === void 0 || (_response$challengeDa4 = response.challengeData) === null || _response$challengeDa4 === void 0 ? void 0 : _response$challengeDa4.autoStartToken,
      imageId: response === null || response === void 0 || (_response$challengeDa5 = response.challengeData) === null || _response$challengeDa5 === void 0 ? void 0 : _response$challengeDa5.imageId
    };
  } catch (error) {
    logger.info('*** Error posting postInitiateDepositAsync Async error code', error === null || error === void 0 ? void 0 : error.code);
    return {
      status: displayStatus.ERROR,
      errorCode: getErrorNumber(error)
    };
  }
};

const postPollDepositStatusAsync = async _ref4 => {
  let paymentId = _ref4.paymentId;
  try {
    const options = {
      method: 'POST',
      path: "/swedbankExpress/".concat(isRc ? '99' : '1', "/pollDepositStatus"),
      data: {
        paymentId
      }
    };
    logger.debug('Call to postPollDepositStatusAsync with options: ', options);
    const _await$jupiter$callAs6 = await jupiter.callAsync(options),
      response = _await$jupiter$callAs6.response;
    logger.debug('Call to postPollDepositStatusAsync response: ', response);
    return {
      status: displayStatus.SUCCESS,
      statusEnum: response.statusEnum,
      accountBalance: response.accountBalance
    };
  } catch (error) {
    logger.info('*** Error posting postPollDepositStatusAsync Async error code', error === null || error === void 0 ? void 0 : error.code);
    return {
      status: displayStatus.ERROR,
      errorCode: getErrorNumber(error)
    };
  }
};
const oneWhitePixel = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';

const getQRImageAsync = async _ref5 => {
  let imageId = _ref5.imageId;
  logger.debug('Call to getQRImageAsync with authorizedId: ', imageId);
  try {
    const options = {
      method: 'GET',
      path: "/swedbankExpress/".concat(isRc ? '99' : '1', "/QRImage?imageId=").concat(imageId)
    };
    logger.debug('Call to getBankAccountsAsync with options: ', options);
    const _await$jupiter$callAs7 = await jupiter.callAsync(options),
      response = _await$jupiter$callAs7.response;
    logger.debug('Call to getBankAccountsAsync response: ', response);
    return {
      status: displayStatus.SUCCESS,
      image: response.qrImage
    };
  } catch (error) {
    logger.info('*** Error getting QRImage Async, error code', error === null || error === void 0 ? void 0 : error.code);
    return {
      status: displayStatus.ERROR,
      errorCode: getErrorNumber(error),
      image: oneWhitePixel
    };
  }
};
svs.accountservicesReact.deposit.services.swedbankExpressService = {
  getBankAccountsAsync,
  getBankListAsync,
  postInitiateDepositAsync,
  postInitiateNewConsentAsync,
  postPollDepositStatusAsync,
  postPollAuthNewBankStatusAsync,
  getQRImageAsync
};

 })(window);